<template>
    <div :class="'pricing-select-block card rounded-3 shadow-sm ' + (selected ? 'border-success' : '')">
        <div :class="'card-header py-3 ' + (selected ? 'text-white bg-success border-success' : '')">
            <h4 class="my-0 fw-normal">
                <slot name="title"></slot>
            </h4>
        </div>
        <div class="card-body">
            <div class="card-title pricing-card-title">
                <slot name="price"></slot>
            </div>
            <ul class="list-unstyled mt-3 mb-4 text-start">
                <slot name="bullets"></slot>
            </ul>

            <button :class="'btn btn-sm w-100 ' + (looptijd === 1 && selected ? 'btn-success' : 'btn-outline-success')" @click="looptijd = 1">
                <i class="fa-solid fa-check ms-2 me-4" v-if="looptijd === 1 && selected"></i> Maandelijks opzegbaar <em>(+€19)</em>
            </button>
            <button :class="'btn btn-sm w-100 mt-2 ' + (looptijd === 12 && selected ? 'btn-success' : 'btn-outline-success')" @click="looptijd = 12">
                <i class="fa-solid fa-check ms-2 me-4" v-if="looptijd === 12 && selected"></i> Minimaal één jaar
            </button>

            <button type="button" :class="'w-100 mt-2 btn btn-lg ' + (selected ? 'btn-success' : 'btn-outline-success')"
                v-html="selectButtonText"
            ></button>
        </div>
    </div>
</template>

<script>

export default {
    components: {},

    props: [
        'type',
        'selected_type',
    ],

    mixins: [],

    data: function () {
        return {
            looptijd: 12,
        };
    },

    computed: {
        selected() {
            return this.type === this.selected_type;
        },
        selectButtonText() {
            let icon = this.selected ? '<i class="fa-solid fa-check me-3"></i>' : '<i class="fa-solid fa-chevron-right me-3"></i>';
            return this.selected ? icon + " Geselecteerd" : icon + 'Selecteer';
        }
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        //
    },

    watch: {
        looptijd() {
            this.$emit('looptijd', this.looptijd);
        },
        selected(value) {
            if(value) {
                this.looptijd = 12;
                this.$emit('looptijd', this.looptijd);
            }
        }
    }
};
</script>
<style lang="scss">
.pricing-select-block {
    &:hover {
        cursor: pointer;
    }
    .pricing-card-title {
        font-size: 2.5rem;
    }
}
</style>
